import type {
  PlumbingItemProperties,
  PlumbingProductId,
  PlumbingState,
} from './plumbing.types';

export const selectSelectedPlumbing = (state: {
  plumbing: PlumbingState;
}): Record<PlumbingProductId, PlumbingItemProperties> =>
  state.plumbing.selectedPlumbing;

export const selectPlumbingQuantity = (
  state: { plumbing: PlumbingState },
  productId: PlumbingProductId
): number => state.plumbing.selectedPlumbing[productId]?.quantity ?? 0;

export const selectIsPlumbingSelected = (
  state: { plumbing: PlumbingState },
  productId: PlumbingProductId
): boolean => state.plumbing.selectedPlumbing[productId]?.isSelected ?? false;
